import styles from './Loader.module.scss'

export default function LoaderProducts() {
	const mockProducts = new Array(10).fill(0)
	return (
		<div className="flex flex-col items-center justify-center width-full border-gray-900\/10 pb-6 gap-3 w-full">
			{
				mockProducts.map((product, id) =>
					<div className="w-full" key={`mock-product-${id}`}>
						<div className="tr flex bg-grey/40 rounded-xl flex-col sm:flex-row gap-6">
							<div className={`${styles.animatePulse} bg-grey/100 z-0 rounded-xl w-full xl:w-96 h-60 object-cover object-center relative bg-center bg-cover`}>
							</div>
							<div className="w-full justify-between flex flex-col-reverse xl:flex-row sm:pb-12 sm:pr-6 h-20">
							</div>
						</div>
					</div>
				)
			}
		</div>
	)
}